/**
 * Safely parse JSON string without throwing errors.
 * Returns null if parsing fails or if the input is not a valid JSON string.
 *
 * @param value - The value to parse
 * @returns Parsed object or null if parsing fails
 */
export function safeJsonParse<T = unknown>(value: unknown): T | null {
  // Only accept strings
  if (typeof value !== "string") {
    return null
  }

  const trimmedValue = value.trim()

  // Quick validation: JSON must start with { or [
  if (!trimmedValue.startsWith("{") && !trimmedValue.startsWith("[")) {
    return null
  }

  try {
    return JSON.parse(trimmedValue) as T
  } catch {
    return null
  }
}

/**
 * Check if a value is a valid JSON string
 */
export function isValidJsonString(value: unknown): boolean {
  return safeJsonParse(value) !== null
}
